export const VERSION = 'plan-editor-v2'
